(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isFinePointer = window.matchMedia('(pointer: fine)').matches;

  /* ---------------------------------------------------------------------
     Scroll reveal
  --------------------------------------------------------------------- */
  function initReveal() {
    var targets = document.querySelectorAll('.reveal, .reveal-scale');
    if (!targets.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    document.querySelectorAll('[data-reveal-group]').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.style.setProperty('--bh-i', i);
      });
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });

    targets.forEach(function (el) { observer.observe(el); });
  }

  /* ---------------------------------------------------------------------
     Cursor glow (desktop only — a small "2030 gadget" touch)
  --------------------------------------------------------------------- */
  function initCursorGlow() {
    if (!isFinePointer || prefersReducedMotion) return;
    var glow = document.createElement('div');
    glow.className = 'bh-cursor-glow';
    document.body.appendChild(glow);

    var raf = null;
    window.addEventListener('pointermove', function (e) {
      glow.classList.add('is-active');
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        glow.style.transform = 'translate(' + e.clientX + 'px,' + e.clientY + 'px)';
      });
    });
    window.addEventListener('pointerleave', function () { glow.classList.remove('is-active'); });
  }

  /* ---------------------------------------------------------------------
     3D tilt on product cards
  --------------------------------------------------------------------- */
  function initTilt() {
    if (!isFinePointer || prefersReducedMotion) return;
    var cards = document.querySelectorAll('.bh-tilt');

    cards.forEach(function (card) {
      var inner = card.querySelector('.bh-tilt-inner') || card;
      var bounds;

      card.addEventListener('pointerenter', function () { bounds = card.getBoundingClientRect(); });

      card.addEventListener('pointermove', function (e) {
        if (!bounds) bounds = card.getBoundingClientRect();
        var px = (e.clientX - bounds.left) / bounds.width - 0.5;
        var py = (e.clientY - bounds.top) / bounds.height - 0.5;
        var rotateY = px * 10;
        var rotateX = py * -10;
        inner.style.transform = 'rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateZ(10px)';
      });

      card.addEventListener('pointerleave', function () {
        inner.style.transform = 'rotateX(0deg) rotateY(0deg) translateZ(0)';
      });
    });
  }

  /* ---------------------------------------------------------------------
     Cart: count bubble + drawer + AJAX add-to-cart
  --------------------------------------------------------------------- */
  var Cart = {
    drawer: null,

    url: function (path) {
      var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      if (root.charAt(root.length - 1) === '/') root = root.slice(0, -1);
      return root + path;
    },

    init: function () {
      this.drawer = document.querySelector('[data-cart-drawer]');
      this.bindTriggers();
      this.bindForms();
      this.bindClose();
    },

    bindTriggers: function () {
      document.querySelectorAll('[data-cart-toggle]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();
          Cart.open();
        });
      });
    },

    bindClose: function () {
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-close]')) Cart.close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') Cart.close();
      });
    },

    open: function () { if (this.drawer) { this.drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; this.refresh(); } },
    close: function () { if (this.drawer) { this.drawer.classList.remove('is-open'); document.body.style.overflow = ''; } },

    bindForms: function () {
      document.addEventListener('submit', function (e) {
        var form = e.target.closest('form[data-bh-add-to-cart]');
        if (!form) return;
        e.preventDefault();
        Cart.add(form);
      });
    },

    add: function (form) {
      var button = form.querySelector('[type="submit"]');
      var errorEl = form.querySelector('[data-cart-error]');
      var formData = new FormData(form);

      if (button) {
        button.classList.add('is-loading');
        button.disabled = true;
      }
      if (errorEl) { errorEl.textContent = ''; errorEl.style.display = 'none'; }

      fetch(Cart.url('/cart/add.js'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (result) {
          if (button) { button.classList.remove('is-loading'); button.disabled = false; }

          if (!result.ok) {
            if (errorEl) {
              errorEl.textContent = result.data && result.data.description ? result.data.description : result.data.message;
              errorEl.style.display = 'block';
            }
            return;
          }

          if (button) {
            button.classList.add('is-added');
            window.setTimeout(function () { button.classList.remove('is-added'); }, 1400);
          }
          Cart.updateCount();
          Cart.open();
        })
        .catch(function () {
          if (button) { button.classList.remove('is-loading'); button.disabled = false; }
          if (errorEl) {
            errorEl.textContent = errorEl.dataset.genericError || '';
            errorEl.style.display = 'block';
          }
        });
    },

    updateCount: function () {
      fetch(Cart.url('/cart.js'))
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.toggle('is-empty', cart.item_count === 0);
          });
        });
    },

    refresh: function () {
      if (!this.drawer) return;
      var content = this.drawer.querySelector('[data-cart-drawer-content]');
      if (!content) return;
      fetch(Cart.url('/cart?view=drawer'), { cache: 'no-store' })
        .then(function (res) { return res.text(); })
        .then(function (html) { content.innerHTML = html; })
        .catch(function () {});
    },

    refreshPage: function () {
      var current = document.querySelector('[data-cart-page]');
      if (!current) return;
      fetch(Cart.url('/cart?section_id=main-cart'), { cache: 'no-store' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-page]');
          if (fresh) current.outerHTML = fresh.outerHTML;
        })
        .catch(function () {});
    }
  };

  /* ---------------------------------------------------------------------
     Mobile nav drawer
  --------------------------------------------------------------------- */
  function initMobileNav() {
    var nav = document.querySelector('[data-mobile-nav]');
    if (!nav) return;
    document.querySelectorAll('[data-mobile-nav-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        nav.classList.toggle('is-open');
        document.body.style.overflow = nav.classList.contains('is-open') ? 'hidden' : '';
      });
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ---------------------------------------------------------------------
     Cart quantity steppers (event delegation, drawer content re-renders)
  --------------------------------------------------------------------- */
  function initQtySteppers() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-plus], [data-qty-minus]');
      if (!btn) return;
      var stepper = btn.closest('[data-qty-stepper]');
      if (!stepper) return;
      var line = stepper.dataset.line;
      var countEl = stepper.querySelector('span');
      var qty = parseInt(countEl.textContent, 10);
      qty = btn.hasAttribute('data-qty-plus') ? qty + 1 : Math.max(0, qty - 1);

      fetch(Cart.url('/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function () { Cart.updateCount(); Cart.refresh(); Cart.refreshPage(); })
        .catch(function () {});
    });
  }

  /* ---------------------------------------------------------------------
     Cart line removal (event delegation, works from drawer or cart page)
  --------------------------------------------------------------------- */
  function initCartRemove() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-remove]');
      if (!btn) return;
      var line = btn.dataset.line;

      fetch(Cart.url('/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      })
        .then(function () { Cart.updateCount(); Cart.refresh(); Cart.refreshPage(); })
        .catch(function () {});
    });
  }

  /* ---------------------------------------------------------------------
     Animated stat counters
  --------------------------------------------------------------------- */
  function initCounters() {
    var counters = document.querySelectorAll('[data-counter]');
    if (!counters.length) return;

    function animate(el) {
      var target = parseFloat(el.dataset.target) || 0;
      var duration = 1400;
      var start = null;

      if (prefersReducedMotion) { el.textContent = target.toLocaleString('nl-NL'); return; }

      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased).toLocaleString('nl-NL');
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) { counters.forEach(animate); return; }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { animate(entry.target); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.5 });
    counters.forEach(function (el) { observer.observe(el); });
  }

  /* ---------------------------------------------------------------------
     Sticky mobile buy bar
  --------------------------------------------------------------------- */
  function initStickyBuyBar() {
    var bar = document.querySelector('[data-sticky-bar]');
    var sentinel = document.querySelector('[data-buy-box]');
    if (!bar || !sentinel || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    observer.observe(sentinel);

    var stickyAdd = bar.querySelector('[data-sticky-add]');
    var mainForm = document.querySelector('[data-bh-add-to-cart]');
    if (stickyAdd && mainForm) {
      stickyAdd.addEventListener('click', function () {
        if (mainForm.requestSubmit) mainForm.requestSubmit();
        else mainForm.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
  }

  /* ---------------------------------------------------------------------
     Product form quantity stepper (pre-cart, just updates hidden input)
  --------------------------------------------------------------------- */
  function initFormQtyStepper() {
    var wrap = document.querySelector('[data-form-qty]');
    if (!wrap) return;
    var valueEl = wrap.querySelector('[data-qty-value]');
    var input = document.querySelector('[data-qty-input]');

    wrap.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-plus], [data-qty-minus]');
      if (!btn) return;
      var qty = parseInt(valueEl.textContent, 10);
      qty = btn.hasAttribute('data-qty-plus') ? qty + 1 : Math.max(1, qty - 1);
      valueEl.textContent = qty;
      if (input) input.value = qty;
    });
  }

  /* ---------------------------------------------------------------------
     Product gallery: thumbnail swap + cursor-magnify zoom
  --------------------------------------------------------------------- */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var mainImg = gallery.querySelector('[data-gallery-main]');
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-dots] .bh-gallery__dot'));
    var swipeArea = gallery.querySelector('[data-gallery-swipe]');
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    var imagesScript = gallery.querySelector('[data-gallery-images]');
    var images = [];
    try { images = imagesScript ? JSON.parse(imagesScript.textContent) : []; } catch (e) { images = []; }
    var currentIndex = 0;

    function goTo(index) {
      if (!images.length) return;
      currentIndex = (index + images.length) % images.length;
      if (mainImg) mainImg.src = images[currentIndex];
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === currentIndex); });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

    if (swipeArea && images.length > 1) {
      var startX = null;
      var startY = null;
      var dragging = false;
      swipeArea.style.touchAction = 'pan-y';

      swipeArea.addEventListener('pointerdown', function (e) {
        startX = e.clientX;
        startY = e.clientY;
        dragging = true;
      });
      swipeArea.addEventListener('pointerup', function (e) {
        if (!dragging || startX === null) { dragging = false; return; }
        dragging = false;
        var deltaX = e.clientX - startX;
        var deltaY = e.clientY - startY;
        startX = null;
        if (Math.abs(deltaX) > 40 && Math.abs(deltaX) > Math.abs(deltaY)) {
          goTo(deltaX < 0 ? currentIndex + 1 : currentIndex - 1);
        }
      });
      swipeArea.addEventListener('pointercancel', function () { dragging = false; startX = null; });
      swipeArea.addEventListener('pointerleave', function () { dragging = false; startX = null; });
    }

    var zoomWrap = gallery.querySelector('[data-gallery-zoom]');
    if (!zoomWrap || !isFinePointer || prefersReducedMotion) return;

    zoomWrap.addEventListener('mousemove', function (e) {
      if (!mainImg) return;
      if (e.target.closest('.bh-gallery__arrow')) {
        mainImg.style.transform = 'scale(1)';
        return;
      }
      var rect = zoomWrap.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      mainImg.style.transformOrigin = x + '% ' + y + '%';
      mainImg.style.transform = 'scale(1.5)';
    });
    zoomWrap.addEventListener('mouseleave', function () {
      if (mainImg) mainImg.style.transform = 'scale(1)';
    });
  }

  /* ---------------------------------------------------------------------
     Variant picker → sync hidden input + price + media
  --------------------------------------------------------------------- */
  function initVariantPicker() {
    document.querySelectorAll('[data-variant-picker]').forEach(function (root) {
      var variants;
      try { variants = JSON.parse(root.querySelector('[data-variant-json]').textContent); } catch (err) { return; }

      var idInput = root.querySelector('[data-variant-id]');
      var priceEl = root.querySelector('[data-variant-price]');
      var comparePriceEl = root.querySelector('[data-variant-compare-price]');
      var submitBtn = root.querySelector('[data-add-to-cart-btn]');
      var stockNotice = root.querySelector('[data-stock-notice]');
      var preorderBadge = root.querySelector('[data-preorder-badge]');
      var preorderNote = root.querySelector('[data-preorder-note]');
      var lowStockThreshold = parseInt(root.dataset.lowStockThreshold, 10) || 5;

      function selectedOptions() {
        var opts = [];
        root.querySelectorAll('[data-option-selected]').forEach(function (el) { opts.push(el.dataset.optionSelected); });
        return opts;
      }

      function findVariant() {
        if (!root.querySelector('[data-option-value]')) return variants[0];
        var opts = selectedOptions();
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }

      function formatMoney(cents) {
        var format = root.dataset.moneyFormat || '€{{amount_with_comma_separator}}';
        var amount = cents / 100;
        var withSeparators = function (n, decimals, thousands, decimalSep) {
          var parts = n.toFixed(decimals).split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return decimals > 0 ? parts.join(decimalSep) : parts[0];
        };
        return format
          .replace('{{amount_no_decimals_with_comma_separator}}', withSeparators(amount, 0, '.', ','))
          .replace('{{amount_with_comma_separator}}', withSeparators(amount, 2, '.', ','))
          .replace('{{amount_no_decimals_with_space_separator}}', withSeparators(amount, 0, ' ', ','))
          .replace('{{amount_with_space_separator}}', withSeparators(amount, 2, ' ', ','))
          .replace('{{amount_with_apostrophe_separator}}', withSeparators(amount, 2, "'", '.'))
          .replace('{{amount_no_decimals}}', withSeparators(amount, 0, ',', '.'))
          .replace('{{amount}}', withSeparators(amount, 2, ',', '.'));
      }

      function applyVariant() {
        var variant = findVariant();
        if (!variant) {
          if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = root.dataset.labelUnavailable || 'Niet beschikbaar'; }
          return;
        }
        if (idInput) idInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (comparePriceEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceEl.textContent = formatMoney(variant.compare_at_price);
            comparePriceEl.style.display = '';
          } else {
            comparePriceEl.style.display = 'none';
          }
        }
        var isPreorder = variant.available && variant.inventory_management === 'shopify' && variant.inventory_quantity <= 0;
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          submitBtn.textContent = isPreorder
            ? (root.dataset.labelPreorder || submitBtn.dataset.labelAvailable)
            : (variant.available ? submitBtn.dataset.labelAvailable : (root.dataset.labelSoldOut || 'Uitverkocht'));
        }
        if (preorderBadge) preorderBadge.style.display = isPreorder ? '' : 'none';
        if (preorderNote) preorderNote.style.display = isPreorder ? '' : 'none';
        if (stockNotice) {
          var isLowStock = variant.inventory_management === 'shopify' && variant.inventory_quantity > 0 && variant.inventory_quantity <= lowStockThreshold;
          if (isLowStock) {
            stockNotice.textContent = (root.dataset.lowStockTemplate || '').replace('__COUNT__', variant.inventory_quantity);
            stockNotice.style.display = '';
          } else {
            stockNotice.style.display = 'none';
          }
        }
      }

      root.querySelectorAll('[data-option-value]').forEach(function (input) {
        input.addEventListener('change', function () {
          root.querySelectorAll('[data-option-name="' + input.dataset.optionName + '"]').forEach(function (el) {
            el.removeAttribute('data-option-selected');
          });
          input.setAttribute('data-option-selected', input.value);
          applyVariant();
        });
      });

      applyVariant();
    });
  }

  /* ---------------------------------------------------------------------
     Product recommendations (fetched client-side per Shopify's API)
  --------------------------------------------------------------------- */
  function initRecommendations() {
    document.querySelectorAll('[data-product-recommendations]').forEach(function (el) {
      fetch(el.dataset.url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById(el.id);
          if (fresh) { el.innerHTML = fresh.innerHTML; initReveal(); initTilt(); }
        })
        .catch(function () {});
    });
  }

  /* ---------------------------------------------------------------------
     Testimonials carousel
  --------------------------------------------------------------------- */
  function initTestimonialsCarousel() {
    document.querySelectorAll('[data-testimonial-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-testimonial-track]');
      var prevBtn = carousel.querySelector('[data-testimonial-prev]');
      var nextBtn = carousel.querySelector('[data-testimonial-next]');
      var dots = carousel.querySelectorAll('[data-testimonial-dot]');
      var slides = track ? track.querySelectorAll('.bh-testimonial-carousel__slide') : [];
      if (!track || !slides.length) return;

      function slideWidth() {
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
        return slides[0].getBoundingClientRect().width + gap;
      }

      function currentIndex() {
        return Math.round(track.scrollLeft / slideWidth());
      }

      function updateDots() {
        var idx = Math.max(0, Math.min(slides.length - 1, currentIndex()));
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === idx); });
        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
        if (nextBtn) nextBtn.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      }

      function goTo(index) {
        index = Math.max(0, Math.min(slides.length - 1, index));
        track.scrollTo({ left: index * slideWidth(), behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex() + 1); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { goTo(parseInt(dot.dataset.index, 10) || 0); });
      });

      var scrollTimer;
      track.addEventListener('scroll', function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(updateDots, 80);
      });
      window.addEventListener('resize', updateDots);
      updateDots();
    });
  }

  /* ---------------------------------------------------------------------
     Announcement bar: auto-rotating messages
  --------------------------------------------------------------------- */
  function initAnnouncementSlider() {
    document.querySelectorAll('[data-announce-slider]').forEach(function (el) {
      var items = el.querySelectorAll('.bh-announce__item');
      if (items.length < 2) return;
      var index = 0;
      window.setInterval(function () {
        items[index].classList.remove('is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-active');
      }, 3500);
    });
  }

  /* ---------------------------------------------------------------------
     Quick-add button on product cards (collection/featured grids)
  --------------------------------------------------------------------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;
      btn.classList.add('is-loading');

      fetch(Cart.url('/cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          if (!result.ok) return;

          btn.classList.add('is-added');
          window.setTimeout(function () { btn.classList.remove('is-added'); }, 1400);
          Cart.updateCount();
          Cart.refresh();
          Cart.open();
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
    });
  }

  /* ---------------------------------------------------------------------
     Boot
  --------------------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCursorGlow();
    initTilt();
    Cart.init();
    initMobileNav();
    initQtySteppers();
    initCartRemove();
    initQuickAdd();
    initCounters();
    initGallery();
    initFormQtyStepper();
    initStickyBuyBar();
    initVariantPicker();
    initRecommendations();
    initTestimonialsCarousel();
    initAnnouncementSlider();
  });

  window.Betrahan = { Cart: Cart };
})();
